export default __webpack_public_path__ + "static/media/More-V.79d4b4d2.svg";